import { mode } from '@chakra-ui/theme-tools';
export const textareaStyles = {
	components: {
		Textarea: {
			defaultProps: {
				variant: 'main',
			},
			baseStyle: {
				fontWeight: 400,
				borderRadius: '8px'
			},

			variants: {
				main: (props: any) => ({
					bg: mode('gray.50', 'whiteAlpha.50')(props),
					border: '1px solid',
					color: mode('secondaryGray.900', 'white')(props),
					borderColor: mode('secondaryGray.100', 'whiteAlpha.100')(props),
					borderRadius: '16px',
					fontSize: 'sm',
					p: '20px',
					transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
					_placeholder: { color: 'secondaryGray.600' },
					_focus: {
						bg: mode('white', 'whiteAlpha.100')(props),
						borderColor: mode('brand.500', 'brand.400')(props),
						boxShadow: mode(
							'0 0 0 2px rgba(2, 63, 127, 0.15)',
							'0 0 0 2px rgba(53, 120, 191, 0.25)'
						)(props),
					},
				}),
				auth: () => ({
					bg: 'white',
					border: '1px solid',
					borderColor: 'secondaryGray.100',
					borderRadius: '16px',
					_placeholder: { color: 'secondaryGray.600' }
				}),
				authSecondary: () => ({
					bg: 'white',
					border: '1px solid',
					borderColor: 'secondaryGray.100',
					borderRadius: '16px',
					_placeholder: { color: 'secondaryGray.600' }
				}),
				search: () => ({
					border: 'none',
					py: '11px',
					borderRadius: 'inherit',
					_placeholder: { color: 'secondaryGray.600' }
				})
			}
		}
	}
};
